import config from "@/config";
import http from "@/utils/request";

export default {
	menu: {
		myMenus: {
			url: `${config.API_URL}/system/menu/my/1.6.1`,
			name: "获取我的菜单",
			get: async function () {
				return await http.get(this.url);
			},
		},
		list: {
			url: `${config.API_URL}/system/menu/list`,
			name: "获取菜单",
			get: async function () {
				return await http.get(this.url);
			},
		},
	},
	dic: {
		tree: {
			url: `${config.API_URL}/system/dic/tree`,
			name: "获取字典树",
			get: async function () {
				return await http.get(this.url);
			},
		},
		list: {
			url: `${config.API_URL}/system/dic/list`,
			name: "字典明细",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		get: {
			url: `${config.API_URL}/system/dic/get`,
			name: "获取字典数据",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	role: {
		list: {
			url: `${config.API_URL}/system/role/list2`,
			name: "获取角色列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	dept: {
		list: {
			url: `${config.API_URL}/system/dept/list`,
			name: "获取部门列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	user: {
		list: {
			url: `${config.API_URL}/system/user/list`,
			name: "获取用户列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	app: {
		list: {
			url: `${config.API_URL}/system/app/list`,
			name: "应用列表",
			get: async function () {
				return await http.get(this.url);
			},
		},
	},
	log: {
		list: {
			url: `${config.API_URL}/system/log/list`,
			name: "日志列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	table: {
		list: {
			url: `${config.API_URL}/system/table/list`,
			name: "表格列管理列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		info: {
			url: `${config.API_URL}/system/table/info`,
			name: "表格列管理详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	tasks: {
		list: {
			url: `${config.API_URL}/system/tasks/list`,
			name: "系统任务管理",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	order: {
		list: {
			url: `${config.API_URL}/orders/of/search/self/page`,
			name: "获取预报订单列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		orderDetail: {
			url: `${config.API_URL}/orders/self/`,
			name: "获取单个预报订单",
			get: async function (params) {
				this.url = `${config.API_URL}/orders/self/` + params;
				return await http.get(this.url);
			},
		},
		orderUpdate: {
			url: `${config.API_URL}/orders/self/`,
			name: "修改预报订单",
			put: async function (data) {
				this.url = `${config.API_URL}/orders/self/` + data.id;
				return await http.put(this.url, data.data);
			},
		},
		batchCreate: {
			url: `${config.API_URL}/orders/batch`,
			name: "批量预报运单",
			post: async function (data) {
				return await http.post(this.url, data);
			},
		},
		batchRealDelete: {
			url: `${config.API_URL}/orders/self/good/datch/`,
			name: "批量彻底删除",
			delete: async function (data) {
				this.url = `${config.API_URL}/orders/self/good/datch/${data}`;
				return await http.delete(this.url);
			},
		},
		batchDelete: {
			url: `${config.API_URL}/orders/self/datch/`,
			name: "批量删除",
			delete: async function (data) {
				this.url = `${config.API_URL}/orders/self/datch/${data}`;
				return await http.delete(this.url);
			},
		},
		templateLabelBatch: {
			url: `${config.API_URL}/templates/of/onekey/batch/`,
			name: "打印标签/发票",
			get: async function (data) {
				if (data.sell_product_id) {
					this.url = `${config.API_URL}/templates/of/onekey/batch/${data.nos}?sell_product_id=${data.sell_product_id}&order=1`;
				} else {
					this.url = `${config.API_URL}/templates/of/onekey/batch/${data.nos}?template_id=${data.template_id}&order=1`;
				}
				return await http.get(this.url);
			},
		},
		templateSellProductBatch: {
			url: `${config.API_URL}/templates/sell_product/self/batch/`,
			name: "打印对接标签/发票",
			get: async function (data) {
				this.url = `${config.API_URL}/templates/sell_product/self/batch/${data.nos}?sell_product_id=${data.sell_product_id}&type_id=${data.type_id}`;
				return await http.get(this.url);
			},
		},
		entry: {
			list: {
				url: `${config.API_URL}/entrys_deprecated/self`,
				name: "获取申报信息",
				get: async function (params) {
					return await http.get(this.url, params);
				},
			},
			add: {
				url: `${config.API_URL}/entrys_deprecated/self`,
				name: "新增申报信息",
				post: async function (data) {
					return await http.post(this.url, data);
				},
			},
			delete: {
				url: `${config.API_URL}/entrys_deprecated/self/datch/`,
				name: "删除申报信息",
				delete: async function (data) {
					this.url = `${config.API_URL}/entrys_deprecated/self/datch/${data}`;
					return await http.delete(this.url);
				},
			},
			edit: {
				url: `${config.API_URL}/entrys_deprecated/self/`,
				name: "修改申报信息",
				put: async function (data) {
					this.url =
						`${config.API_URL}/entrys_deprecated/self/` + data.id;
					return await http.put(this.url, data.data);
				},
			},
		},
	},
	common: {
		upload: {
			url: `${config.API_URL}/system_statics/upload/inof?ipurl=${config.BASE_URL}`,
			name: "上传文件",
			post: async function (formData) {
				return await http.post(this.url, formData);
			},
		},
		sellProductGet: {
			url: `${config.API_URL}/sell_products/`,
			name: "根据id获取销售产品",
			get: async function (data) {
				this.url = `${config.API_URL}/sell_products/` + data;
				return await http.get(this.url);
			},
		},
	},
};
